import { Box, Stack, Typography } from "@mui/material";

// import CreateDevicesFromTemplateDialogContainer from "./CreateDevicesFromTemplateDialogContainer";
import { useAuthenticatedUser } from "../../../common/hooks/useAuthenticatedUser";
import { RoleEnum } from "../../../common/models/enums";
import CreateDevicesFromSKUDialogContainer from "./CreateDevicesFromSKUDialogContainer";

export const DEVICE_TEMPLATE_ADMIN_ACCESS = [
  RoleEnum.ROOT,
  RoleEnum.CC_OPS_ADMIN,
  RoleEnum.CC_OPS,
];

const DevicesPageHeader = (): JSX.Element => {
  const { role } = useAuthenticatedUser();

  return (
    <Box padding="0" marginBottom="1em">
      <Stack spacing={4} direction="row" alignItems="center">
        <Typography variant="h3" padding={0} sx={{ flexGrow: 1 }}>
          Devices
        </Typography>
        {DEVICE_TEMPLATE_ADMIN_ACCESS.includes(role) && (
          <>
            {/* <CreateDevicesFromTemplateDialogContainer /> */}
            <CreateDevicesFromSKUDialogContainer />
          </>
        )}
        {/* <CreateDeviceDialogContainer /> */}
      </Stack>
    </Box>
  );
};

export default DevicesPageHeader;
